import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { LocalService } from './local.service';

export type NcModeType = 'horizontal' | 'vertical';

@Component({
  selector: 'nc-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.less']
})
export class TimelineComponent implements OnChanges {
  /** 时间轴数据 */
  @Input() ncDate: any[] = [];//['2022-03-01', '2022-06-11', '2023-04-10', '2023-12-22', '2024-02-27', '2024-05-11']
  /** 方向 */
  @Input() ncMode: NcModeType = 'horizontal';
  /** 当前选中index，可双向绑定 */
  @Input() ncSelected: number = -1;
  /** 主轴线颜色 */
  @Input() ncAxisColor: string = '#969696';
  /** 时间轴项颜色 */
  @Input() ncItemColor: string = '#969696';
  /** 时间轴项悬停颜色 */
  @Input() ncItemHoverColor: string = '#ffbc02';
  /** 时间轴项选中颜色 */
  @Input() ncItemSelectedColor: string = '#ff3918';
  /** 刻度颜色 */
  @Input() ncScaleColor: string = '#969696';
  /** 刻度文字颜色 */
  @Input() ncScaleTextColor: string = '#8e8e8e';
  /** 选中项改变事件 */
  @Output() ncSelectedChange = new EventEmitter();
  /** 点击事件 */
  @Output() ncClick = new EventEmitter();

  scaleArr: Array<any> = [];
  dateObjectArr: Array<any> = [];
  scaleObjectArr: Array<any> = [];

  constructor(private ls: LocalService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ncDate']) {
      this.init();
    }
  }

  init() {
    //时间值
    this.dateObjectArr = this.setLeftValue(this.ncDate);

    //刻度值
    this.scaleArr = [this.ncDate[0], this.ncDate[this.ncDate.length - 1]];//['2022-03-01', '2024-05-11']
    this.scaleArr = this.scaleArr.map(date => new Date(date));
    let minYear = Math.min(...this.scaleArr.map(date => date.getFullYear()));//2022
    let maxYear = Math.max(...this.scaleArr.map(date => date.getFullYear()));//2024
    //插入year-01-01，'2023-01-01', '2024-01-01'
    for (let year = minYear + 1; year <= maxYear; year++) {
      let newYearDate = new Date(`${year}-01-01`);
      this.scaleArr.push(newYearDate);
    }
    //排序
    this.scaleArr.sort((a, b) => a - b);
    //转化为字符串
    this.scaleArr = this.scaleArr.map(date => this.ls.formatDate('yyyy-MM-dd', date));//['2022-03-01','2023-01-01', '2024-01-01', '2024-05-11']
    //获取left值
    this.scaleObjectArr = this.setLeftValue(this.scaleArr);
    //截取年份
    for (let item of this.scaleObjectArr) {
      item.date = item.date.substring(0, 4);
    }
    //删除用于计算的首尾值
    this.scaleObjectArr.splice(0, 1);
    this.scaleObjectArr.splice(this.scaleObjectArr.length - 1, 1);
  }

  //获取定位left值
  setLeftValue(arr: Array<any>) {
    let all = this.ls.getRangeDate(new Date(arr[0]), new Date(arr[arr.length - 1])).length;
    let leftArr: Array<any> = [];
    for (let i = 0; i < arr.length; i++) {
      let value = i == 0 ? 0 : this.ls.getRangeDate(new Date(arr[0]), new Date(arr[i])).length;
      leftArr.push({
        date: arr[i],
        left: this.ls.retainPercentDecimal(value / all, 2)
      });
    }
    return leftArr;
  }

  itemClick(date: string, index: number) {
    this.ncClick.emit({ date, index });
    this.ncSelected = index;
    this.ncSelectedChange.emit(this.ncSelected);
  }
}
